module.exports = __webpack_public_path__ + "media/images/pricing/pricing-premium-429df1d7f859b762732090ec8fc614c4.svg";